<twc-toggle class="twc-ml-3 twc-mt-3 twc-mb-2">
    <input twcToggleInput #inputToggle [attr.checked]="propertyValue ? true: null" [disabled]="!property.editable()"
        (change)="onChange(inputToggle.checked)">
    <label twcToggleLabel>{{label | translate}}</label>
</twc-toggle>